import React, { useState, useEffect } from 'react';
import { Container, Box, Grid, Paper } from '@mui/material';
import TemplateSelection from './TemplateSelection';
import ScheduleEditor from './ScheduleEditor';
import ChaguimEditor from './ChaguimEditor';
import ZmanimEditor from './ZmanimEditor';
import AdContentManager from './AdContentManager';
import SponsorManager from './SponsorManager';
import TopBar from '../components/topbar/TopBar';
import CommmunitySetting from './CommunitySetting';
import ShiurEditor from './ShiurEditor'; // Import de la nouvelle page
import RoomEditor from './RoomEditor';
import RavEditor from './RavEditor';
import NavigationMenu from '../components/navigation/NavigationMenu';
import LayoutBuilder from './LayoutBuilder';
import BillingPage from './BillingPage';
import { useAuth } from '../AuthContext'; // Importer le contexte
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from '../components/dialogs/ConfirmDialog';
import { AlertDialog } from '../components/dialogs/AlertDialog';

function AdminDashboard() {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState(0);
  const navigate = useNavigate();
  const { user, isTokenExpired, logout } = useAuth(); // Accéder à l'état global
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false); // Suivi des modifications non enregistrées
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [alertDialogOpen, setAlertDialogOpen] = useState(false);
  const [pendingTabChange, setPendingTabChange] = useState(null);

  // Redirection si l'utilisateur n'est pas connecté
  useEffect(() => {
    if (!user.userId || isTokenExpired()) {
      navigate("/"); // Rediriger vers la page d'accueil
    }
  }, [user, navigate]);

  const handleTabChange = (index) => {
    if (isTokenExpired()) {
      setAlertDialogOpen(true);
      return;
    }

    if (isDirty) {
      setPendingTabChange(index);
      setConfirmDialogOpen(true);
      return;
    }
    
    setSelectedTab(index);
  };

  const handleConfirmLeave = () => {
    setIsDirty(false);
    setSelectedTab(pendingTabChange);
    setConfirmDialogOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  return (
    <Container maxWidth="lg" sx={{ overflowX: "hidden" }}>
      <Box sx={{ maxWidth: "100%", overflowX: "hidden" }}>
      {/* Passer la fonction de changement d'onglet à AppAppBar */}
      <TopBar user={user} toggleMobileMenu={toggleMobileMenu} />
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, mt: 2 }}>
          {/* Affichage du menu */}
          <Box sx={{ mr: 2 }}>
            <NavigationMenu
                onTabChange={handleTabChange}
                isMobileOpen={isMobileOpen}
                toggleMobileMenu={toggleMobileMenu} // Passer toggleMobileMenu
                isDirty={isDirty} // Transmettre l'état isDirty
              />
          </Box>

          {/* Contenu principal — minWidth:0 pour que le flex ne s’étire pas au-delà du viewport */}
          <Box sx={{ flexGrow: 1, minWidth: 0, maxWidth: "100%", overflowX: "hidden" }}>
            <Grid container sx={{ minWidth: 0 }}>
              <Grid item xs={12} sx={{ minWidth: 0, maxWidth: "100%" }}>
                <Paper style={{ padding: '16px', overflowX: 'hidden', boxSizing: 'border-box', maxWidth: '100%' }}>
                  {selectedTab === 0 && <TemplateSelection userId={user.userId} onIsDirtyChange={setIsDirty}/>}
                  {selectedTab === 10 && <LayoutBuilder onIsDirtyChange={setIsDirty} />}
                  {selectedTab === 1 && <ScheduleEditor onIsDirtyChange={setIsDirty}/>}
                  {selectedTab === 2 && <ChaguimEditor onIsDirtyChange={setIsDirty}/>}
                  {selectedTab === 9 && <ZmanimEditor onIsDirtyChange={setIsDirty}/>}
                  {selectedTab === 3 && <AdContentManager onIsDirtyChange={setIsDirty}/>}
                  {selectedTab === 4 && <SponsorManager communityId={user.communityId} />}
                  {selectedTab === 5 && <ShiurEditor onIsDirtyChange={setIsDirty}/>} 
                  {selectedTab === 6 && <RavEditor onIsDirtyChange={setIsDirty}/>}
                  {selectedTab === 7 && <RoomEditor onIsDirtyChange={setIsDirty}/>}
                  {selectedTab === 8 && <CommmunitySetting user={user} />}
                  {selectedTab === 11 && <BillingPage />}
                </Paper>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>

      <ConfirmDialog
        open={confirmDialogOpen}
        title={t('common.unsavedChanges')}
        message={t('common.confirmLeave')}
        confirmText={t('common.leave')}
        cancelText={t('common.cancel')}
        onConfirm={handleConfirmLeave}
        onCancel={() => setConfirmDialogOpen(false)}
        severity="warning"
      />

      <AlertDialog
        open={alertDialogOpen}
        title={t('common.sessionExpired')}
        message={t('common.pleaseLogin')}
        buttonText={t('common.ok')}
        onClose={() => {
          setAlertDialogOpen(false);
          logout();
          navigate("/");
        }}
        severity="error"
      />
    </Container>
  );
}

export default AdminDashboard;
